import { SwingHeroEligible, SwingHeroInEligible, SwingHeroNotYetEligible } from "main";

export type SwingHeroProps = {
  subDaysWorked: number;
  score?: number;
  isSwingHero: boolean;
  isSwingHeroEligible?: boolean;
  isHourly: boolean;
  onClick?: {
    requestsOnClick: () => void;
    skillBuilderOnClick: () => void;
  };
};

export function SwingHero(props: SwingHeroProps) {
  const { subDaysWorked, score, isSwingHero, isHourly, onClick, isSwingHeroEligible } = props;
  const shouldRenderNotYetEligible = subDaysWorked < 5 || score === undefined;

  return (
    <>
      {isSwingHeroEligible === false ? (
        <SwingHeroInEligible isHourly={isHourly} onClick={onClick?.skillBuilderOnClick} />
      ) : shouldRenderNotYetEligible ? (
        <SwingHeroNotYetEligible
          subDaysWorked={subDaysWorked}
          isHourly={isHourly}
          onClick={onClick?.requestsOnClick}
        />
      ) : (
        <SwingHeroEligible
          score={score}
          isSwingHero={isSwingHero}
          isHourly={isHourly}
          onClick={onClick?.requestsOnClick}
        />
      )}
    </>
  );
}
